/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionEligibilityCheckResponse
 */
export interface CompetitionEligibilityCheckResponse {
    /**
     * True when the requesting user passes every configured pre-match check for this competition. False when at least one check failed; see `reason` + `failedCheck`.
     * @type {boolean}
     * @memberof CompetitionEligibilityCheckResponse
     */
    allowed: boolean;
    /**
     * Operator-readable failure reason. Surfaced verbatim in the "why am I not eligible?" UI panel. Only present when allowed=false.
     * @type {string}
     * @memberof CompetitionEligibilityCheckResponse
     */
    reason?: string;
    /**
     * Stable id of the failure. Lets clients render check-specific call-to-action UI without parsing the reason string. Live values: `dateOfBirthMissing` (no date of birth on file — ask for one and retry), `minimumAge` (outside the allowed age range), `jurisdictionContest` (blocked location). Only present when allowed=false.
     * @type {string}
     * @memberof CompetitionEligibilityCheckResponse
     */
    failedCheck?: string;
}

/**
 * Check if a given object implements the CompetitionEligibilityCheckResponse interface.
 */
export function instanceOfCompetitionEligibilityCheckResponse(value: object): value is CompetitionEligibilityCheckResponse {
    if (!('allowed' in value) || value['allowed'] === undefined) return false;
    return true;
}

export function CompetitionEligibilityCheckResponseFromJSON(json: any): CompetitionEligibilityCheckResponse {
    return CompetitionEligibilityCheckResponseFromJSONTyped(json, false);
}

export function CompetitionEligibilityCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionEligibilityCheckResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'failedCheck': json['failedCheck'] == null ? undefined : json['failedCheck'],
    };
}

export function CompetitionEligibilityCheckResponseToJSON(json: any): CompetitionEligibilityCheckResponse {
    return CompetitionEligibilityCheckResponseToJSONTyped(json, false);
}

export function CompetitionEligibilityCheckResponseToJSONTyped(value?: CompetitionEligibilityCheckResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'reason': value['reason'],
        'failedCheck': value['failedCheck'],
    };
}

